import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  colors,
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: colors.blue[900],
  },
  actions: {
    backgroundColor: colors.blue[900],
  },
  button: {
    color: "white",
  },
  divider: {
    height: "100%",
    width: "2px",
    backgroundColor: "red",
    color: "red",
  },
}));

const ConfirmDialog = ({
  message,
  onConfirm = () => {},
  onClose = () => {},
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleConfirm = () => {
    setOpen(false);
    onConfirm();
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
          <Box>
            <ErrorIcon fontSize="large" className={classes.icon} />
          </Box>
          <Box mt={1}>
            <Typography variant="h3">
              {t("calendar_event.confirm_dialog_title")}
            </Typography>
          </Box>
          <Box mt={1}>
            <Typography variant="body2">{message}</Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions className={classes.actions}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width={1}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width={1}
          >
            <Button
              fullWidth
              className={classes.button}
              onClick={handleConfirm}
            >
              {t("calendar_event.confirm_button")}
            </Button>
            <Button fullWidth className={classes.button} onClick={handleClose}>
              {t("calendar_event.cancel_button")}
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
